import { c as _c } from "react/compiler-runtime";
import { useNoSponsorshipsCta } from '../../utils/contentful.ts';
import { AffinityCardCta } from '../affinity-card-cta/affinity-card-cta.tsx';
export const PrimaryCtaNoSponsorships: React.FC = () => {
  const $ = _c(2);
  const content = useNoSponsorshipsCta();
  let t0;
  if ($[0] !== content) {
    t0 = content ? <AffinityCardCta {...content} /> : null;
    $[0] = content;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};